@let blok = block();

<div [class]="baseClass+ '-pricing'">
    <h2 [ngClass]="[baseClass + '-pricing-heading',
                  baseClass +'-pricing-heading-color--' + blok.headingColor,
                  baseClass + '-pricing-heading-text-align--'+ blok.headingTextAlign]">{{ blok.headingTextContent }}</h2>
  @if(blok.price) {
      <p [ngClass]="baseClass+ '-pricing-paragraph'">ab {{ blok.price | absoluteValue | currency: blok.currency }}
          <span [ngClass]="baseClass+'-pricing-paragraph-span' ">/ Monat</span></p>
  }
</div>
<div [ngClass]="baseClass + '-list-container'">
    <ul [ngClass]="baseClass + '-list-container-list'">
        @for (child of blok.children; track child['_uid']) {
            <s1-cms-component [blok]="child" />
        }
    </ul>
</div>
<div [ngClass]="baseClass + '-footer'">
    <div [ngClass]="baseClass + '-footer-button'">
        <p>Tarif errechnen</p>
        <div [ngClass]="baseClass + '-footer-button-div'"></div>
    </div>
    @if (blok.link?.linktype === 'url') {
        <a [href]="blok.link?.url">zum Produkt</a>
    } @else {
        <a [routerLink]="['/cms/' + blok.link?.cached_url]">zum Produkt</a>
    }
</div>
